import React, { useMemo, useRef, useState } from 'react';
import {
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grid,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import PropTypes from 'prop-types';

export const SplitButton = ({
  onClick,
  options = [],
  onOptionSelect,
  icon,
  optionNameKey,
  optionValueKey,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const handleMenuItemClick = (option) => {
    setSelectedIndex(option.value);
    setOpen(false);
    if (onOptionSelect) {
      onOptionSelect(option);
    }
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const formattedOptions = useMemo(() => {
    if (typeof options?.[0] === 'object' && optionNameKey && optionValueKey) {
      return options.map((option) => ({
        ...option,
        label: option[optionNameKey],
        value: option[optionValueKey],
      }));
    }
    return options.map((option) => ({ label: option, value: option }));
  }, [options, optionNameKey, optionValueKey]);

  const selectedOption = useMemo(
    () =>
      formattedOptions.find((option) => option.value === selectedIndex)?.label,
    [selectedIndex]
  );

  if (typeof options?.[0] === 'object' && !optionNameKey && !optionValueKey) {
    return <strong>please provide optionNameKey and optionValueKey</strong>;
  }

  return (
    <Grid container direction='column' alignItems='center' className='w-auto'>
      <Grid item xs={12}>
        <ButtonGroup
          variant='contained'
          color='primary'
          ref={anchorRef}
          aria-label='split button'
        >
          <Button onClick={onClick}>
            {icon} {selectedOption}
          </Button>
          <Button
            color='primary'
            size='small'
            aria-controls={open ? 'split-button-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-label='select merge strategy'
            aria-haspopup='menu'
            onClick={handleToggle}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortals
          style={{
            zIndex: 1000000,
          }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList id='split-button-menu'>
                    {formattedOptions.map((option, index) => (
                      <MenuItem
                        key={option.label}
                        selected={option.value === selectedIndex}
                        onClick={() => handleMenuItemClick(option)}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </Grid>
    </Grid>
  );
};

SplitButton.propTypes = {
  onClick: PropTypes.func,
  options: PropTypes.array,
  onOptionSelect: PropTypes.func,
  icon: PropTypes.node,
  optionNameKey: PropTypes.string,
  optionValueKey: PropTypes.string,
};
